<template>
    <div class="center-text"> 
        <lay-panel> 
               <div class="loginText">登录口</div>
            <lay-form :model="user" :pane="true">
                <lay-form-item label="账户" prop="userName">
                    <lay-input v-model="user.userName"></lay-input>
                </lay-form-item>
              
                <lay-form-item label="密码" prop="passWord">
                    <lay-input v-model="user.password" type="passWord"></lay-input>
                </lay-form-item> 

                <lay-form-item label="验证码" prop="passWord">
                    <div class="input-group captcha-group">
                        <input
                            type="text"
                            id="captcha"
                            v-model="user.captcha"
                            placeholder="请输入验证码"
                        />
                        <img :src="'data:image/jpeg;base64,'+captchaSrc" @click="reloadCaptcha" class="captcha-img" />
                    
                        </div>
  
                </lay-form-item> 

             

                <lay-form-item>
                    <lay-button type="primary" @click="submit2">提交</lay-button>
                </lay-form-item>
            </lay-form>

        </lay-panel>

    </div>
</template>
<script lang="ts" setup>
import { ref, reactive } from 'vue'
import router from '../../router'
import { layer } from '@layui/layer-vue'
import {login,getCaptcha} from '../../api'
import { setToken,removeToken,setUserName } from '@/utils/auth'
import md5 from 'js-md5';

 


  // 响应式变量
  const user = reactive({
    userName: "",
    password: "",
    captcha:"",
    codeKey:""

})

  const captchaSrc=ref("")
const  reloadCaptcha=function () {
    getCaptcha().then((res: any) => {
        if (res!=""&&res.code == 0) {  
            captchaSrc.value=res.data
        }
    })
    
}

reloadCaptcha();



 
const submit2 = function () {
    removeToken();
    

    if(user.userName.length==0||user.password.length==0){ 
            layer.msg("账号或者密码不能为空", { icon : 2, time: 1000}) 
            return false;
        }

        if(user.captcha.length==0){ 
      layer.msg("请输入验证码", { icon : 2, time: 1000}) 
      return false;
  }


        user.codeKey=md5.md5(captchaSrc.value); 
        login(JSON.stringify(user)).then((res: any) => {
            if (res!=""&&res.code == 0) { 
                setUserName(user.userName);
                setToken(res.data);
                layer.msg("登录成功", { icon : 1, time: 1000}) 
                router.push({ path: '/' }) 
            }else{
              reloadCaptcha();

            }  
        })
 
};

</script>

<style >

  
  .input-group input { 
    padding: 10px;
    border: 1px solid #ccc;  
    line-height: 17px;
  }
  
  /* 验证码输入框和验证码图片的样式 */
  .captcha-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .captcha-group input {
    width: 100%;
  }
  
  .captcha-img {
    width: 30%;
    height: auto;
    cursor: pointer;
    margin-left: 2px;
    box-shadow: 0 4px 12px #d1d0d0;
  }
  

.loginText{

  font-size: 16px;
  padding: 10px;

}
.center-text {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
    /* 100% of the viewport height */
}
</style>